import { DataReceived, NewAdaptPractAndOrgn, AdaptPractAndOrgn, currentLocationPos, AdaptPractAndOrgnArgs } from '../../interfaces/interfaces';
import newItem from './newItem';
import { isRole, isLocation, isOrganization, isPractitioner } from './tsHelper';

const compose = (f: NewAdaptPractAndOrgn, g: AdaptPractAndOrgn) => (args: AdaptPractAndOrgnArgs, currentLocation: currentLocationPos | null) => {
  return f.call(null, g.call(null, args), currentLocation);
};

const adaptPractitionersAndOrganizations: AdaptPractAndOrgn = (data) => {
  const mapPractitionerOrOrgan = new Map();
  const practitioner = new Map();
  const organization = new Map();
  const location = new Map();
  const role = new Map();
  let totalNumber = 0;
  const isPractitionerSearch = data.nameOfSearch === 'practitioner';

  if (data) {
    data.res.forEach((item: DataReceived) => {
      item.data.forEach((i) => {
        if (isOrganization(i)) {
          organization.set(i.id, i);
        }
        if (isPractitioner(i)) {
          practitioner.set(i.id, i);
        }
        if (isRole(i)) {
          if (isPractitionerSearch) mapPractitionerOrOrgan.set(i.id, i);
          role.set(i.id, i);
        }
        if (isLocation(i)) {
          if (!isPractitionerSearch) mapPractitionerOrOrgan.set(i.id, i);
          location.set(i.id, i);
        }
      });
      totalNumber += item?.total ?? 0;
    });
  }

  return {
    data: mapPractitionerOrOrgan,
    practitioner,
    organization,
    location,
    role,
    total: totalNumber ?? 0,
  };
};

const newEntryPractitionerAndOrganization = compose(newItem, adaptPractitionersAndOrganizations);

export default newEntryPractitionerAndOrganization;
